// extracted by mini-css-extract-plugin
export var phoneNumber = "CallOurReservationTeam-module--phone-number--13c53";